import React from "react";
import {
	Box,
	Grid,
	Typography,
	IconButton,
	Button,
	TextField,
	Autocomplete,
	LinearProgress,
} from "@mui/material";
import { alpha } from "@mui/system";
import { Add, Delete, WifiOutlined } from "@mui/icons-material";

export default function OnuSection({
	theme,
	labelErp,
	servicoHostOnus,
	handleOnuChange,
	handleAddOnu,
	handleRemoveOnu,
	generateCombinedOptions,
	loadingServices,
}) {
	return (
		<Box
			sx={{
				p: 2,
				bgcolor: theme.palette.background.paper,
				borderRadius: "12px",
				width: "100%",
				mb: 1,
			}}
		>
			{/* Cabeçalho */}
			<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
				<Box
					sx={{
						backgroundColor: alpha(theme.palette.primary.main, 0.2),
						borderRadius: "10px",
						width: "35px",
						height: "35px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<WifiOutlined
						fontSize="small"
						sx={{
							color:
								theme.palette.mode === "dark"
									? theme.palette.primary.light
									: theme.palette.primary.dark,
						}}
					/>
				</Box>
				<Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
					ONUs
				</Typography>
			</Box>

			{servicoHostOnus.map((item, index) => {
				const combinedOptions = generateCombinedOptions();
				const filteredOptions = combinedOptions.filter(
					(opt) =>
						!servicoHostOnus?.some(
							(selected, i) =>
								i !== index &&
								selected?.servico?.id_cliente_servico ===
									opt?.servico?.id_cliente_servico &&
								selected?.host?.hostid === opt?.host?.hostid &&
								selected?.onu?.onuItem === opt?.onu?.onuItem,
						),
				);
				const currentValue =
					combinedOptions.find(
						(option) =>
							option?.servico?.id_cliente_servico ===
								item?.servico?.id_cliente_servico &&
							option?.host?.hostid === item?.host?.hostid &&
							option?.onu?.onuItem === item?.onu?.onuItem,
					) || null;

				return (
					<Box
						key={index}
						sx={{
							border: "1px solid",
							borderColor: theme.palette.divider,
							pb: 2,
							pl: 2,
							pr: 2,
							borderRadius: "12px",
							mt: 2,
						}}
					>
						<Grid container spacing={1} sx={{ mt: 1, alignItems: "center" }}>
							<Grid item xs={12} sm={11}>
								<Box
									sx={{
										position: "relative",
										display: "flex",
										flexDirection: "column",
										gap: 1,
									}}
								>
									{loadingServices && (
										<LinearProgress
											sx={{
												position: "absolute",
												top: -5,
												left: 0,
												right: 0,
											}}
										/>
									)}
									<Autocomplete
										disabled={loadingServices}
										size="small"
										options={filteredOptions}
										value={currentValue}
										noOptionsText="Nenhum equipamento encontrado"
										getOptionLabel={(option) => option?.label || ""}
										onChange={(_, newValue) => handleOnuChange(index, newValue)}
										fullWidth
										renderInput={(params) => (
											<TextField
												{...params}
												label={`${labelErp} | Host | ONU`}
												size="small"
												sx={{
													"& .MuiOutlinedInput-root": {
														borderRadius: "12px",
													},
												}}
											/>
										)}
									/>
								</Box>
							</Grid>

							<Grid
								item
								xs={12}
								sm={1}
								sx={{ display: "flex", justifyContent: "center" }}
							>
								<IconButton
									size="small"
									onClick={() => handleRemoveOnu(index)}
									disabled={servicoHostOnus.length === 1}
								>
									<Delete
										color={
											servicoHostOnus.length === 1 ? "disabled" : "error"
										}
										fontSize="small"
									/>
								</IconButton>
							</Grid>
						</Grid>
					</Box>
				);
			})}

			<Grid item xs={12} sx={{ mt: 2 }}>
				<Button
					size="small"
					variant="outlined"
					startIcon={<Add />}
					onClick={handleAddOnu}
					sx={{ width: "100%", borderRadius: "8px" }}
					disabled={loadingServices}
				>
					Adicionar Equipamento
				</Button>
			</Grid>
		</Box>
	);
}
